import PropTypes from "prop-types";
import React from "react";
import "./styles.css";

// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";

// MUI
import { Grid, Stack } from "@mui/material";

// Constants
const GRID_CLASSES = "simple-transition";

const getRightDelta = (input, deltas = null) => {
	switch (input) {
		case "Percent":
			return deltas?.percent || 0.01;
		case "Dollar":
			return deltas?.dollar || 0.01;
		default:
			return deltas?.unit || 0.5;
	}
};

export default function ComposedRow(props) {
	const {
		index = 0,
		hasShadow = false,
		spaces = null,
		item = null,
		metrics = {
			input: "Dollar",
			decimalsEditable: true,
			decimals: 2,
		},
		deltas = {
			percent: 0.01,
			dollar: 0.01,
			unit: 0.01,
		},
		fromDisabled = false,
		toDisabled = false,
		errors = null,
		readOnly = false,
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	return (
		<TierRowsItem hasShadow={hasShadow} spaces={spaces}>
			<Grid container item columnSpacing={5.5}>
				<Grid item xs={12} md={6} className={GRID_CLASSES}>
					<DoubleInput
						firstInput={{
							data: [
								{
									type: metrics?.input || "Dollar",
									min: 0,
									max: 10000,
									decimalsEditable: metrics?.decimalsEditable || false,
									decimals: metrics?.decimals || 2,
									dashed: fromDisabled,
									delta: getRightDelta(metrics?.input, deltas),
									disabled: true,
								},
							],
							value: item?.from?.value || 0,
							defaultType: item?.from?.input || "Dollar",
							error: errors?.from || false,
							disabled: fromDisabled || readOnly,
							sx: { maxWidth: "95px", minWidth: "95px" },
							onActionUpdate: (value) => {
								onActionUpdate?.(index, "from", value);
							},
							onChangeType: (_, input) => {
								onChangeType?.(index, "from", input);
							},
						}}
						secondInput={{
							data: [
								{
									type: metrics?.input || "Dollar",
									min: 0,
									max: 10000,
									decimalsEditable: metrics?.decimalsEditable || false,
									decimals: metrics?.decimals || 2,
									dashed: toDisabled,
									delta: getRightDelta(metrics?.input, deltas),
								},
							],
							value: item?.to?.value || 0,
							defaultType: item?.to?.input || "Dollar",
							error: errors?.to || false,
							disabled: toDisabled || readOnly,
							sx: { maxWidth: "95px", minWidth: "95px" },
							onActionUpdate: (value, input) => {
								onActionUpdate?.(index, "to", value, getRightDelta(input, deltas));
							},
							onChangeType: (_, input) => {
								onChangeType?.(index, "to", input);
							},
						}}
					/>
				</Grid>
				<Grid item xs={12} md={3} className={GRID_CLASSES}>
					<Stack width={"95px"}>
						<InputFormExtension
							data={[
								{
									type: "Percent",
									min: 0,
									max: 100,
									decimalsEditable: true,
									decimals: 2,
									delta: deltas?.percent || 0.01,
								},
								{
									type: "Dollar",
									min: 0,
									max: 100000,
									decimalsEditable: false,
									decimals: 2,
									delta: deltas?.dollar || 1,
								},
							]}
							value={item?.cash?.value || 0}
							defaultType={item?.cash?.input || "Percent"}
							disabled={readOnly}
							error={errors?.cash || false}
							onActionUpdate={(value) => {
								onActionUpdate?.(index, "cash", value);
							}}
							onChangeType={(_, input) => {
								onChangeType?.(index, "cash", input);
							}}
						/>
					</Stack>
				</Grid>
				<Grid item xs={12} md={3} className={GRID_CLASSES}>
					<Stack width={"95px"}>
						<InputFormExtension
							data={[
								{
									type: "Percent",
									min: 0,
									max: 100,
									decimalsEditable: true,
									decimals: 2,
									delta: deltas?.percent || 0.01,
								},
								{
									type: "Dollar",
									min: 0,
									max: 100000,
									decimalsEditable: false,
									decimals: 2,
									delta: deltas?.dollar || 1,
								},
							]}
							value={item?.lease?.value || 0}
							defaultType={item?.lease?.input || "Percent"}
							disabled={readOnly}
							error={errors?.lease || false}
							onActionUpdate={(value) => {
								onActionUpdate?.(index, "lease", value);
							}}
							onChangeType={(_, input) => {
								onChangeType?.(index, "lease", input);
							}}
						/>
					</Stack>
				</Grid>
			</Grid>
		</TierRowsItem>
	);
}
ComposedRow.propTypes = {
	index: PropTypes.number,
	hasShadow: PropTypes.bool,
	spaces: PropTypes.object,
	item: PropTypes.shape({
		from: PropTypes.shape({
			value: PropTypes.number,
			input: PropTypes.string,
		}),
		to: PropTypes.shape({
			value: PropTypes.number,
			input: PropTypes.string,
		}),
		cash: PropTypes.shape({
			value: PropTypes.number,
			input: PropTypes.string,
		}),
		lease: PropTypes.shape({
			value: PropTypes.number,
			input: PropTypes.string,
		}),
	}),
	metrics: PropTypes.shape({
		input: PropTypes.string,
		decimalsEditable: PropTypes.bool,
		decimals: PropTypes.number,
	}),
	deltas: PropTypes.shape({
		percent: PropTypes.number,
		dollar: PropTypes.number,
		unit: PropTypes.number,
	}),
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	errors: PropTypes.shape({
		from: PropTypes.bool,
		to: PropTypes.bool,
		cash: PropTypes.bool,
		lease: PropTypes.bool,
	}),
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	onChangeType: PropTypes.func,
};
